import { z } from "zod";

import { zSchema } from "../../../../entity";

import { zWithLanguage } from "~/shared/zod";

const zIn = zSchema
  .pick({
    id: true,
  })
  .merge(
    zSchema
      .omit({
        id: true,
        category: true,
      })
      .extend({
        categoryId: zSchema.shape.category.shape.id,
        features: z.array(
          zSchema.shape.features.element
            .pick({
              id: true,
            })
            .merge(
              zSchema.shape.features.element
                .omit({
                  id: true,
                })
                .partial(),
            ),
        ),
      })

      .partial(),
  )
  .merge(zWithLanguage);
type In = z.infer<typeof zIn>;

export { zIn };
export type { In };
